module.exports = "https://cdn.hellotech.com/client-assets/virtual-services-desktop_2ccfe3407847b15e35ed3a98a8023356.png";